module.exports = __webpack_public_path__ + "assets/img/img-mv.9a430ba3.jpg";